@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="ims-wrap glb-popup inbox-mail-sms">

  <div class="d-flex justify-content-between align-items-center">
    <div class="ims-titlebar__text">
      @if (formReadOnly) {
        <h3>{{ inbox.subject }}</h3>
      }
      @if (!formReadOnly) {
        <h2>{{ formTitle }}</h2>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      @if (showClose) {
        <button type="button" [mat-dialog-close]="showClose" class="ims-close-btn">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      }
    </div>
  </div>

  @if (formAlert) {
    <div class="ims-alert">
      <i class="pi pi-exclamation-triangle"></i>
      <b>{{ formAlert }}</b>
    </div>
  }

  <div [formGroup]="form1">

    <div class="ims-context-row" [hidden]="!isSendEnable">
      <div class="ims-field ims-field--grow" [hidden]="!isSendEnable">
        <label for="msgTemplateId" class="ims-label">Select Template</label>
        <p-dropdown class="w-100" [filter]="true" filterBy="msgTemplateId,name"
          [options]="msgTemplates"
          formControlName="msgTemplateId"
          dropdownIcon="fa fa-caret-down"
          optionLabel="name"
          optionValue="msgTemplateId"
          placeholder="Template"
          [style]="{ width: '100%' }"

          (onChange)="selectTemplate($event, 0)">
          <ng-template let-msgTemplate pTemplate="item">
            <table>
              <tr>
                <td style="width:50px;text-align:left;">#{{ msgTemplate.msgTemplateId }}</td>
                <td style="width:200px;text-align:left;white-space:normal;word-break:break-word;">
                  {{ getAudienceName(msgTemplate.msgAudience) }}
                </td>
                <td>{{ msgTemplate.name }}</td>
              </tr>
            </table>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="ims-field">
        <label class="ims-label">Msg Context</label>
        <p-dropdown
          appendTo="body"
          dropdownIcon="fa fa-caret-down"
          [options]="msgContexts"
          [(ngModel)]="msgContextId"
          [ngModelOptions]="{ standalone: true }"
          [filter]="true"
          optionLabel="name"
          optionValue="value"
          placeholder="Msg Context"
          [disabled]="msgTopic == 100"
          [style]="{ width: '100%' }"
          (onChange)="onMsgContextChange($event.value)">
        </p-dropdown>
      </div>
      <div class="ims-field">
        <label class="ims-label">Msg Sub Context</label>
        <p-dropdown
          appendTo="body"
          dropdownIcon="fa fa-caret-down"
          [options]="msgSubContexts"
          [(ngModel)]="msgSubContextId"
          [ngModelOptions]="{ standalone: true }"
          [filter]="true"
          optionLabel="name"
          optionValue="value"
          placeholder="Msg Sub Context"
          [style]="{ width: '100%' }">
        </p-dropdown>
      </div>
      <div class="ims-field ">
        <label class="ims-label">Template Audiences</label>
        <p-multiSelect
          appendTo="body"
          dropdownIcon="fa fa-caret-down"
          [options]="msgAudiences"
          displaySelectedLabel
          optionLabel="name"
          optionValue="value"
          [(ngModel)]="selectedAudiences"
          [ngModelOptions]="{ standalone: true }"
          (onChange)="onAudienceChange($event.value)"
          display="chip"
          [displaySelectedLabel]="true"
          [style]="{ width: '100%' }">
        </p-multiSelect>
      </div>
    </div>

    <div class="ims-channel-toggle" [hidden]="!isSendEnable">
      <span class="ims-toggle-label">Send via:</span>
      <button
        type="button"
        class="ims-ch-card ims-ch-card--email"
        [ngClass]="{ 'ims-ch-card--active': sendViaEmail }"
        (click)="sendViaEmail = !sendViaEmail">
        <i class="pi pi-envelope"></i>
        <span>Email</span>
      </button>
      <button
        type="button"
        class="ims-ch-card ims-ch-card--sms"
        [ngClass]="{ 'ims-ch-card--active': sendViaSms }"
        (click)="sendViaSms = !sendViaSms">
        <i class="pi pi-mobile"></i>
        <span>SMS</span>
      </button>
    </div>


    <div class="ims-panels"
      [class.ims-panels--email-only]=" sendViaEmail && !sendViaSms"
      [class.ims-panels--sms-only]="  !sendViaEmail && sendViaSms"
      [class.ims-panels--both]="       sendViaEmail &&  sendViaSms"
      [hidden]="!isSendEnable">

      @if (sendViaEmail) {
        <div class="ims-panel ims-panel--email">
          <div class="ims-panel-head">
            <span class="ims-panel-badge ims-panel-badge--email">
              <i class="pi pi-envelope"></i> Email
            </span>
          </div>
          @if (!selectedTemplateId || !reservations || reservations.length < 1) {
            <div class="ims-rcpt-grid">
              <div class="ims-rcpt-row">
                <span class="ims-rcpt-lbl">To:</span>
                <div class="ims-rcpt-val">
                  @if (defaultContacts.length > 0) {
                    <app-contact-select
                      (contactSelectedEvent)="toMailSelected($event)" [contacts]="defaultContacts">
                    </app-contact-select>
                  }
                  @if (defaultContacts.length == 0) {
                    <app-contact-select
                      (contactSelectedEvent)="toMailSelected($event)" [contacts]="defaultContacts">
                    </app-contact-select>
                  }
                </div>
              </div>
              <div class="ims-rcpt-row">
                <span class="ims-rcpt-lbl">CC:</span>
                <div class="ims-rcpt-val">
                  <app-contact-select (contactSelectedEvent)="ccMailSelected($event)"></app-contact-select>
                </div>
              </div>
              <div class="ims-rcpt-row">
                <span class="ims-rcpt-lbl">BCC:</span>
                <div class="ims-rcpt-val">
                  <app-contact-select (contactSelectedEvent)="bccMailSelected($event)"></app-contact-select>
                </div>
              </div>
            </div>
            <div style="position:relative;">
              @if (isTemplateLoading) {
                <div class="ims-overlay-loader">
                  <i class="pi pi-spin pi-spinner" style="font-size:2rem;"></i>
                </div>
              }
              <div class="ims-rcpt-row ims-subject-row">
                <input pInputText class="ims-subject-input" type="text"
                  formControlName="subject" id="subject" placeholder="Enter subject…">
                  @for (validation of validationMessages.subject; track validation) {
                    <span>
                      @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                        <small class="p-invalid"
                          >
                          {{ validation.message }}
                        </small>
                      }
                    </span>
                  }
                </div>
                @if (formReadOnly) {
                  <div class="ims-section">
                    <label>
                      @if (inbox?.senderName != inbox?.subject) {
                        <span><b>{{ inbox.senderName }}</b></span>
                      }
                      &lt;{{ inbox.senderEmail }}&gt;
                    </label>
                  </div>
                }
                @if (formReadOnly && !inbox?.emailText) {
                  <span class="p-float-label required-field w-100 mb-3">
                    <editor formControlName="emailHtml" id="emailHtml23" class="taskTinyMce"
                      [disabled]="formReadOnly" toolbar="false"
								[init]="{
									height: 400, base_url: '/tinymce', suffix: '.min', menubar: false,
									plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
									toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
                    </editor>
                  </span>
                }
                @if (!formReadOnly && !inbox?.emailText) {
                  <span class="p-float-label required-field w-100 mb-3">
                    <editor formControlName="emailHtml" id="emailHtml2" class="taskTinyMce"
                      [disabled]="formReadOnly"
								[init]="{
									height: 400, base_url: '/tinymce', suffix: '.min', menubar: true,
									plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
									toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
                    </editor>
                  </span>
                }
              </div>
              @if (inbox?.emailText) {
                <div class="ims-section">
                  <span class="fp-float-label required-field w-100 mb-3">
                    <label for="emailText">Email Text</label>
                    <textarea formControlName="emailText" id="emailText" [rows]="3"
                    pInputTextarea [disabled]="formReadOnly"></textarea>
                  </span>
                </div>
              }
            }
            @if (selectedTemplateId && reservations && reservations.length > 0) {
              <div formArrayName="reservationForms">
                @for (resGroup of reservationForms.controls; track resGroup; let i = $index) {
                  <div
                    [formGroupName]="i" class="ims-res-block">
                    <div class="ims-res-header">
                      <i class="pi pi-calendar"></i> Reservation {{ i + 1 }}
                    </div>
                    <div class="ims-section" [hidden]="!isSendEnable">
                      <span class="p-float-label mb-3">
                        <p-dropdown class="w-100" [filter]="true" filterBy="msgTemplateId,name"
                          [options]="msgTemplates"
                          formControlName="msgTemplateId"
                          optionLabel="name"
                          optionValue="msgTemplateId"
                          placeholder="Template"
                          [style]="{ width: '100%' }"
                          (onChange)="selectTemplate($event, i)">
                          <ng-template let-msgTemplate pTemplate="item">
                            <div class="flex align-items-center">
                              <div>#{{ msgTemplate.msgTemplateId }} {{ msgTemplate.name }}</div>
                            </div>
                          </ng-template>
                        </p-dropdown>
                        <label for="msgTemplateId">Select Template</label>
                      </span>
                    </div>
                    <div class="ims-rcpt-grid">
                      <div class="ims-rcpt-row">
                        <span class="ims-rcpt-lbl">TO&nbsp;:&nbsp;</span>
                        <div class="ims-rcpt-val">
                          <app-contact-select (contactSelectedEvent)="toMailSelected($event)"
                            [contacts]="resGroup.controls.toMailIds.value">
                          </app-contact-select>
                        </div>
                      </div>
                      <div class="ims-rcpt-row">
                        <span class="ims-rcpt-lbl">CC&nbsp;:&nbsp;</span>
                        <div class="ims-rcpt-val">
                          <app-contact-select (contactSelectedEvent)="ccMailSelected($event)"></app-contact-select>
                        </div>
                      </div>
                      <div class="ims-rcpt-row">
                        <span class="ims-rcpt-lbl">BCC&nbsp;:&nbsp;</span>
                        <div class="ims-rcpt-val">
                          <app-contact-select (contactSelectedEvent)="bccMailSelected($event)"></app-contact-select>
                        </div>
                      </div>
                    </div>
                    <div style="position:relative;">
                      @if (isTemplateLoading) {
                        <div class="ims-overlay-loader">
                          <i class="pi pi-spin pi-spinner" style="font-size:2rem;"></i>
                        </div>
                      }
                      <div class="ims-rcpt-row ims-subject-row">
                        <span class="ims-rcpt-lbl">SUBJECT&nbsp;:&nbsp;</span>
                        <div class="ims-rcpt-val">
                          <input pInputText class="ims-subject-input" type="text"
                            formControlName="subject" id="subject{{i}}" placeholder="Enter subject…">
                            @for (validation of validationMessages.subject; track validation) {
                              <span>
                                @if (form1.get('subject').hasError(validation.type) && (form1.get('subject').dirty || form1.get('subject').touched)) {
                                  <small class="p-invalid"
                                    >
                                    {{ validation.message }}
                                  </small>
                                }
                              </span>
                            }
                          </div>
                        </div>
                        <div class="ims-section">
                          <span class="p-float-label w-100 mb-3">
                            <p-fileUpload name="files[]" [chooseIcon]="'pi pi-paperclip'"
                              (onSelect)="myUploader($event)" [auto]="true"
                              fileLimit="5" multiple="multiple"
                              accept=".jpg,.jpeg,.gif,.pdf,.xls,.xlsx" maxFileSize="31457280">
                              <ng-template pTemplate="content">
                                @if (resGroup.value.files?.length) {
                                  <ul>
                                    @for (file of resGroup.value.files; track file) {
                                      <li>{{ file.name }} – {{ file.size }} bytes</li>
                                    }
                                  </ul>
                                }
                              </ng-template>
                            </p-fileUpload>
                          </span>
                        </div>
                        @if (formReadOnly) {
                          <div class="ims-section">
                            <label>
                              @if (inbox?.senderName != inbox?.subject) {
                                <span><b>{{ inbox.senderName }}</b></span>
                              }
                              &lt;{{ inbox.senderEmail }}&gt;
                            </label>
                          </div>
                        }
                        @if (formReadOnly && !inbox?.emailText) {
                          <span class="p-float-label required-field w-100 mb-3">
                            <editor formControlName="emailHtml" id="emailHtml{{i}}" class="taskTinyMce"
                              [disabled]="formReadOnly" toolbar="false"
									[init]="{height:400, base_url:'/tinymce', suffix:'.min', menubar:false,
										plugins:'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
										toolbar:'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
                            </editor>
                          </span>
                        }
                        @if (!formReadOnly && !inbox?.emailText) {
                          <span class="p-float-label required-field w-100 mb-3">
                            <editor formControlName="emailHtml" id="emailHtml{{i}}" class="taskTinyMce"
                              [disabled]="formReadOnly"
									[init]="{height:400, base_url:'/tinymce', suffix:'.min', menubar:true,
										plugins:'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
										toolbar:'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
                            </editor>
                          </span>
                        }
                      </div>
                      @if (inbox?.emailText) {
                        <div class="ims-section">
                          <span class="fp-float-label required-field w-100 mb-3">
                            <label for="emailText-{{ i }}">Email Text</label>
                            <textarea formControlName="emailText" id="emailText-{{ i }}" [rows]="3"
                            pInputTextarea [disabled]="formReadOnly"></textarea>
                          </span>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }

          @if (sendViaSms) {
            <div class="ims-panel ims-panel--sms">
              <div class="ims-panel-head">
                <span class="ims-panel-badge ims-panel-badge--sms">
                  <i class="pi pi-mobile"></i> SMS
                </span>
              </div>
              @if (!selectedTemplateId || !reservations || reservations.length < 1) {
                <div class="ims-rcpt-row">
                  <span class="ims-rcpt-lbl">To:</span>
                  <div class="ims-sms-to">
                    <span class="p-float-label required-field ims-sms-country">
                      <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="countries" formControlName="mobileCountryCode"
                        optionLabel="name" optionValue="dial" placeholder="Country Code">
                      </p-dropdown>
                      <label for="mobileCountryCode">Country</label>
                      @for (validation of validationMessages.mobileCountryCode; track validation) {
                        <span>
                          @if (form1.get('mobileCountryCode').hasError(validation.type) && (form1.get('mobileCountryCode').dirty || form1.get('mobileCountryCode').touched)) {
                            <small class="p-invalid"
                              >
                              {{ validation.message }}
                            </small>
                          }
                        </span>
                      }
                    </span>
                    <span class="p-float-label required-field ims-sms-number">
                      <input formControlName="mobileNum" id="mobileNum" type="text" pInputText>
                      <label for="mobileNum">Mobile Number</label>
                      @for (validation of validationMessages.mobileNum; track validation) {
                        <span>
                          @if (form1.get('mobileNum').hasError(validation.type) && (form1.get('mobileNum').dirty || form1.get('mobileNum').touched)) {
                            <small class="p-invalid"
                              >
                              {{ validation.message }}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                </div>
                <div class="ims-rcpt-row ims-sms-msg-row">
                  <span class="ims-rcpt-lbl">Msg:</span>
                  @if (formReadOnly) {
                    <span class="p-float-label required-field w-100">
                      <textarea pInputTextarea [autoResize]="true" formControlName="mobileText" id="mobileText"
                      [disabled]="formReadOnly" class="ims-sms-textarea"></textarea>
                    </span>
                  }
                  @if (!formReadOnly) {
                    <span class="p-float-label required-field w-100">
                      <textarea pInputTextarea [autoResize]="true" formControlName="mobileText" id="mobileText"
                        [disabled]="formReadOnly" class="ims-sms-textarea"
                      placeholder="Type SMS message…"></textarea>
                    </span>
                  }
                </div>
              }
              @if (selectedTemplateId && reservations && reservations.length > 0) {
                <div formArrayName="reservationForms">
                  @for (resGroup of reservationForms.controls; track resGroup; let i = $index) {
                    <div
                      [formGroupName]="i" class="ims-res-block">
                      <div class="ims-res-header">
                        <i class="pi pi-calendar"></i> Reservation {{ i + 1 }}
                      </div>
                      <div class="ims-rcpt-row">
                        <span class="ims-rcpt-lbl">To:</span>
                        <div class="ims-sms-to">
                          <span class="p-float-label required-field ims-sms-country">
                            <p-dropdown class="w-100" [options]="countries" formControlName="mobileCountryCode"
                              optionLabel="name" optionValue="dial" placeholder="Country Code">
                            </p-dropdown>
                            <label for="mobileCountryCode-{{i}}">Country</label>
                            @for (validation of validationMessages.mobileCountryCode; track validation) {
                              <span>
                                @if (form1.get('mobileCountryCode').hasError(validation.type) && (form1.get('mobileCountryCode').dirty || form1.get('mobileCountryCode').touched)) {
                                  <small class="p-invalid"
                                    >
                                    {{ validation.message }}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                          <span class="p-float-label required-field ims-sms-number">
                            <input formControlName="mobileNum" id="mobileNum{{i}}" type="text" pInputText>
                            <label for="mobileNum{{i}}">Mobile Number</label>
                            @for (validation of validationMessages.mobileNum; track validation) {
                              <span>
                                @if (form1.get('mobileNum').hasError(validation.type) && (form1.get('mobileNum').dirty || form1.get('mobileNum').touched)) {
                                  <small class="p-invalid"
                                    >
                                    {{ validation.message }}
                                  </small>
                                }
                              </span>
                            }
                          </span>
                        </div>
                      </div>
                      <div class="ims-rcpt-row ims-sms-msg-row">
                        <span class="ims-rcpt-lbl">Msg:</span>
                        @if (formReadOnly) {
                          <span class="p-float-label required-field w-100">
                            <textarea pInputTextarea [autoResize]="true" formControlName="mobileText" id="mobileText-{{ i }}"
                            [disabled]="formReadOnly" class="ims-sms-textarea"></textarea>
                          </span>
                        }
                        @if (!formReadOnly) {
                          <span class="p-float-label required-field w-100">
                            <textarea pInputTextarea [autoResize]="true" formControlName="mobileText" id="mobileText-{{ i }}"
                              [disabled]="formReadOnly" class="ims-sms-textarea"
                            placeholder="Type SMS message…"></textarea>
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

        </div>

        @if (isSendEnable && (sendViaEmail || sendViaSms)) {
          <div class="mail-files-section">
            <input #mailFileInput type="file" class="mail-file-input" multiple
              accept="image/jpeg,image/png,image/gif,image/bmp,image/webp,audio/mpeg,audio/mp4,audio/wav,audio/ogg,audio/amr,video/mp4,video/3gpp,text/plain,text/x-vcard,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              (change)="onFileSelected($event)">
              <button type="button" class="attach-btn" (click)="mailFileInput.click()">
                <i class="pi pi-paperclip" aria-hidden="true"></i>
                <span>Attach</span>
              </button>
              @if (uploadedFiles.length) {
                <div class="attachment-grid">
                  @for (file of uploadedFiles; track file; let i = $index) {
                    <div class="attachment-card">
                      <div class="attachment-card-thumb">
                        @if (isPdf(file)) {
                          <i class="pi pi-file-pdf" aria-hidden="true"></i>
                        }
                        @if (!isPdf(file)) {
                          <i class="pi pi-file"     aria-hidden="true"></i>
                        }
                      </div>
                      <div class="text-start">
                        <div class="attachment-card-name" [title]="file.name">{{ file.name }}</div>
                        <div class="attachment-card-size">{{ formatFileSize(file.size) }}</div>
                      </div>
                      <div class="attachment-card-actions">
                        <button type="button" class="btn-attach-view" (click)="viewAttachment(file)">
                          <i class="pi pi-eye" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="btn-attach-delete" (click)="removeAttachment(i)">
                          <i class="pi pi-trash" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="ims-footer" [hidden]="!isSendEnable">
            <button pButton
              [disabled]="(!sendViaEmail && !sendViaSms) || formLoading"
              class="ims-send-btn p-button"
              (click)="sendMail()">
              <i class="pi pi-send"></i>
              @if ( sendViaEmail && !sendViaSms) {
                <span>Send Email</span>
              }
              @if (!sendViaEmail &&  sendViaSms) {
                <span>Send SMS</span>
              }
              @if ( sendViaEmail &&  sendViaSms) {
                <span>Send Email &amp; SMS</span>
              }
              @if (!sendViaEmail && !sendViaSms) {
                <span>Send</span>
              }
            </button>
          </div>

          @if (!isSendEnable && inboxId) {
            <div class="ims-footer">
              <button pButton [disabled]="!isReplyEnable" class="ims-send-btn p-button" (click)="replyMail()">
                <i class="pi pi-reply"></i> Reply
              </button>
            </div>
          }

        </div>

      </div>
